<!-- Module Switcher: mega menu opens only from the main module control -->
<div
  class="flex items-center gap-1.5 h-10 pl-1.5 pr-2 rounded-full bg-soft-bg"
  role="group"
  [attr.aria-label]="'Module: ' + (navigationState.currentModuleName() | translate)"
>
  <!-- Main module control — opens mega menu -->
  <button
    type="button"
    (click)="onToggle($event)"
    class="flex items-center gap-2 h-8 pl-0 pr-1.5 rounded-full
           hover:bg-gray-100 transition-all duration-200 cursor-pointer outline-none widget-focus-ring"
    [attr.aria-expanded]="navigationState.megaMenuOpen()"
    aria-haspopup="dialog"
    [attr.aria-label]="(navigationState.currentModuleName() | translate) || 'Modules'"
  >
    <span
      class="grid place-items-center h-7 w-7 rounded-full text-white shrink-0"
      [style.background]="navigationState.currentModuleColor()"
    >
      @if (navigationState.currentModule()?.icon) {
        <app-module-icon
          [iconName]="navigationState.currentModule()!.icon"
          [width]="13"
          [height]="13"
          [white]="true"
        ></app-module-icon>
      }
    </span>

    @if (navigationState.currentModuleName()) {
      <span class="truncate max-w-[120px] text-sm font-semibold text-dark-text">
        {{ navigationState.currentModuleName() | translate }}
      </span>
    }

    <ic-chevron-down
      class="shrink-0 transition-transform duration-200"
      [class.rotate-180]="navigationState.megaMenuOpen()"
      [height]="12"
      [width]="12"
      startColor="var(--color-primary-end-color)"
      endColor="var(--color-primary-start-color)"
      [opacity]="0.6"
    ></ic-chevron-down>
  </button>

  <!-- Screen label — display only; does not open mega menu -->
  @if (navigationState.currentScreenName()) {
    <span class="text-gray-300 font-normal select-none" aria-hidden="true">/</span>
    <span
      class="truncate max-w-[140px] text-sm text-gray-text font-medium pr-1"
      [attr.aria-current]="navigationState.currentScreen() ? 'page' : null"
    >
      {{ navigationState.currentScreenName() | translate }}
    </span>
  }
</div>
